import React from 'react';

import DashboardUI from './Dashboard';

export default function Dashboard() {
    return <DashboardUI
    />
}